// START IMPORTS
import { BrandThemeProvider } from '@ltvco/refresh-lib/theme';
import { DateUtil, useScreenSize } from '@ltvco/refresh-lib/utils';
import { useSession } from '@ltvco/refresh-lib/v1';
import { GrowthbookWrapper } from '@ltvco/refresh-lib/v2';
import { useEffect, useState } from 'react';

import { theme } from 'theme';
// END IMPORTS

// START HELPER_FUNCTIONS
function determineIfNewUser(account: any, date: string) {
  const dateUtil = new DateUtil();
  const joinDate = account?.account?.user_info.join_date;

  if (joinDate) {
    return dateUtil.isAfter(joinDate, date);
  }
  return false;
}
// END HELPER_FUNCTIONS

export function Growthbook({ children }: { children: JSX.Element }) {
  // START HOOKS_AND_QUERIES
  const {
    session: { account },
  } = useSession();
  const { isMobile } = useScreenSize();
  // END HOOKS_AND_QUERIES

  // START STATE_MANAGEMENT
  const [customAttributes, setCustomAttributes] = useState<
    Record<string, unknown>
  >({});
  // END STATE_MANAGEMENT

  // START DERIVED_DATA_AND_UTILS
  const deviceType = isMobile ? 'web-mobile' : 'desktop';
  // END DERIVED_DATA_AND_UTILS

  // START EFFECTS
  useEffect(() => {
    if (!account) {
      return;
    }
    setCustomAttributes({
      'prop-2232-new': determineIfNewUser(
        account,
        '2024-04-17T12:00:00.000-04:00'
      ),
      'device-type': deviceType,
      pdf_access:
        !!account?.account?.subscription_info?.subscription_features
          ?.pdf_access,
      is_user_in_recycling: account?.account?.user_info?.user_in_recycling,
      is_user_mobile_subscription:
        account?.account?.subscription_info['mobile_subscription?'],
    });
  }, [account]);
  // END EFFECTS

  // START RENDER
  return (
    <GrowthbookWrapper
      enableDevMode={true}
      apiHost={'https://gbbv.beenverified.com'}
      clientKey={'sdk-sH9Cly3zfuFM9mdc'}
      decryptionKey={'nZwGIW+xki4yOM6qBBx8Kg=='}
      subscribeToChanges={false}
      customAttributes={customAttributes}
      brandName={'numberguru'}
    >
      <BrandThemeProvider theme={theme}>{children}</BrandThemeProvider>
    </GrowthbookWrapper>
  );
  // END RENDER
}
